import { Button, Flex, Tooltip } from "antd";
import type { ReactElement } from "react";

export type TableAction = {
  key: string;
  icon: ReactElement;
  onClick: () => void;
  disabled?: boolean | (() => boolean);
  tooltip?: string;
  danger?: boolean;
};

type TableActionProps = {
  actions: TableAction[];
};

export const TableActions = (props: TableActionProps) => {
  const { actions } = props;

  return (
    <Flex gap={4} wrap={false}>
      {actions.map((action) => (
        <Tooltip key={action.key} title={action.tooltip} placement="top">
          <Button
            disabled={
              action.disabled instanceof Function ? action.disabled() : action.disabled
            }
            danger={action.danger}
            size="small"
            type="text"
            onClick={action.onClick}
          >
            {action.icon}
          </Button>
        </Tooltip>
      ))}
    </Flex>
  );
};
